module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select7.cecb52e1.png";